// config.js

export const SALENG_GREEN_API_PROD = "https://api.saleng.tjl.co.th";
// export const SALENG_GREEN_API_DEV = "http://localhost:8001";
// export const SALENG_SHOP_API_PROD = "https://shop-api.saleng.tjl.co.th";
export const SALENG_SHOP_API_PROD = "https://api.akka.getkaset.com";
// export const SALENG_SHOP_API_PROD = "http://localhost:9002";



